var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('h1',{staticClass:"site-slogon m-0 text-left text-md-right",domProps:{"innerHTML":_vm._s(_vm.$t('siteSlogon'))}}),_c('FrontSwiper')],1)}
var staticRenderFns = []

export { render, staticRenderFns }